<template>
  <div class="feature-slider-area section-space--pt_60">
    <div class="feature-slider position-relative">
      <div class="feature-slider__container">
        <div class="feature-slider__wrapper">
          <swiper :options="swiperOption">
            <swiper-slide v-for="(item, index) in pageItems" :key="index">
              <div class="feature-slider__single-slide">
                <div class="feature-slider__single-slide-wrapper">
                  <div class="row align-items-center">
                    <div class="col-md-6 wow move-up">
                      <div class="image">
                        <img :src="item.src_file" class="img-fluid" alt="" />
                      </div>
                    </div>
                    <div class="col-md-6 wow move-up">
                      <div class="content">
                        <h4 class="title">
                          {{ handleTitleTranslation(item.title) }}
                        </h4>
                        <div class="text">
                          {{ handleDescriptionTranslation(item.title, index) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
            <div
              class="swiper-pagination swiper-pagination--vertical swiper-pagination-1"
              slot="pagination"
            ></div>
            <div
              class="swiper-pagination swiper-pagination--horizontal swiper-pagination-1 hideIfLarge"
              slot="pagination"
              style="height: 50px !important"
            ></div>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*


1/1
Our supply scope is covering a wide spectrum of pump standards, materials and applications that fulfill the requirement various sectors of industry like marine, power production, oil and gas, chemicals, petrochemicals, marine, naval, fish farming…..etc.
Our expertise extents their services to our valuable clients supporting them sine the selection of the proper pump that serve their purpose going through the installation, commissioning, testing ending with putting the supplied pumps into service.
*/
export default {
  name: "featureTwo",
  data() {
    return {
      // array of alll of the items of any carousel in any page
      items: [
        // industrial carousel components
        {
          title: "Industrial",
          src_file:
            "https://firebasestorage.googleapis.com/v0/b/mining-israa-group.appspot.com/o/website%2Findustrial%2FindustrialCarousel1.webp?alt=media&token=f1d432df-d86e-4070-855c-a7841f49ffb4",
          description:
            "This sector in specific represents the launching point of Israa company and refers back to the year 1990, when we supplied our first hydraulic control room to our valuable client “Alexandria national iron and steel co (EZDK now)”.",
        },
        {
          title: "Industrial",
          src_file:
            "https://firebasestorage.googleapis.com/v0/b/mining-israa-group.appspot.com/o/website%2Findustrial%2FindustrialCarousel2.webp?alt=media&token=2e347090-baba-473d-a433-2564854c0690",

          description: `Our supply scope is covering a wide spectrum of pump standards, materials and applications that fulfill the requirement various sectors of industry like marine, power production, oil and gas, chemicals, petrochemicals, marine, naval, fish farming…..etc.`,
        },
        {
          title: "Industrial",
          src_file:
            "https://firebasestorage.googleapis.com/v0/b/mining-israa-group.appspot.com/o/website%2Findustrial%2FindustrialCarousel3.webp?alt=media&token=35f0c22f-9969-4f47-bce7-130252a71f50",
          description: `Our expertise extents their services to our valuable clients supporting them sine the selection of the proper pump that serve their purpose going through the installation, commissioning, testing ending with putting the supplied pumps into service.`,
        },
        {
          title: "Industrial",
          src_file:
            "https://firebasestorage.googleapis.com/v0/b/mining-israa-group.appspot.com/o/website%2Findustrial%2FindustrialCarousel4.webp?alt=media&token=32256381-6623-4f33-8cb6-c5b789ddf93e",
          description: `Our lengthy customer list includes hundreds of reputable industry pioneer companies.`,
        },
        //fish farming carousel component
        {
          title: "Fish",
          src_file:
            "https://firebasestorage.googleapis.com/v0/b/mining-israa-group.appspot.com/o/website%2Ffish-farming%2Fcarouselfishfarm3.webp?alt=media&token=ad9c3895-ce1e-4b46-8e18-c0e7aba3a67c",
          description: `By providing technology focused on solving the biological challenges, ISRAA group along with our partners M/S AKVA group contribute to the continued development of a sustainable a profitable industry for our customers.This premise for everything we deliver from single components to complete installations.`,
        },
        {
          title: "Fish",
          src_file:
            "https://firebasestorage.googleapis.com/v0/b/mining-israa-group.appspot.com/o/website%2Ffish-farming%2Fcarouselfishfarm4.webp?alt=media&token=74445338-b1b0-4c2d-b206-843b13772f3f",
          description: `Good operational performance and fish welfare are paramount in achieving good results, and investing in technology will help deliver both.Putting together all of your business's data, rearrange and present in an appealing way to highlight your core values, services, and visions in the local area. Your online website would be a stepping stone for expanding company's visibility.`,
        },
        //Marine carousel components
        {
          title: "Marine",
          src_file:
            "https://firebasestorage.googleapis.com/v0/b/mining-israa-group.appspot.com/o/website%2Fmarine-navy%2FmarineCarousel6.webp?alt=media&token=8369de52-a9bd-4bb3-9165-c26357b01e72",
          description: `Our business portfolio is comprehensive, starting of supplying genuine parts for marine equipment, extending to supply of main marine equipment`,
        },
        {
          title: "Marine",
          src_file:
            "https://firebasestorage.googleapis.com/v0/b/mining-israa-group.appspot.com/o/website%2Fmarine-navy%2FmarineCarousel2.webp?alt=media&token=79a14145-db6f-481e-9db4-f5a3f8cab536",
          description: `Our main clients are recognized shipbuilding companies, the Egyptian Navy, Port authorities, fishing vessels and so many others.`,
        },
        {
          title: "Marine",
          src_file:
            "https://firebasestorage.googleapis.com/v0/b/mining-israa-group.appspot.com/o/website%2Fmarine-navy%2FmarineCarousel1.webp?alt=media&token=dc417017-4947-4a8f-9529-b76395134c8f",
          description: `Our main business partners include but not limited to: Mitsubishi marine engines / Deutz marine engines / ZF transmission / GERONIMO NAVAL  DESIGN /  Michigan Marine Propulsion`,
        },
        //Oil carousel components
        {
          title: "Oil",
          src_file:
            "https://firebasestorage.googleapis.com/v0/b/mining-israa-group.appspot.com/o/website%2Foil-spilling-combating%2FoilCarousel3.webp?alt=media&token=6eefdf6d-5e0b-42c9-85bc-6b1e4648cb25",
          description: `Throughout the latest decade Israa supplied the Egyptian market with a wide spectrum of quality oil spill combat products provided with our international market leaders manufacturers, specially Lamor corporation of Finland.`,
        },
        {
          title: "Oil",
          src_file:
            "https://firebasestorage.googleapis.com/v0/b/mining-israa-group.appspot.com/o/website%2Foil-spilling-combating%2FoilCarousel2.webp?alt=media&token=70fd0f09-0eb8-4d6d-b16a-92b5c7cf6d98",
          description: `Our product portfolio comprise but not limited to: Oil containment booms of all types / Oil skimmers of all types / Power packs / Storage reels and racks / Absorbent booms, pads and rolls.`,
        },
        // {
        //   title: "Oil",
        //   src_file:
        //     "https://firebasestorage.googleapis.com/v0/b/mining-israa-group.appspot.com/o/website%2Foil-spilling-combating%2FoilCarousel1.webp?alt=media&token=588b7300-e152-4d3a-8df8-ec7e815a032d",
        //   description: `Any text`,
        // },
        //Pump carousel components
        {
          title: "Pump",
          src_file:
            "https://firebasestorage.googleapis.com/v0/b/mining-israa-group.appspot.com/o/website%2Fpumps%2FpumpsCarousel1.webp?alt=media&token=67257079-b3bd-4d33-8cc6-c5f4d50dafd6",
          description: `Our supply scope is covering a wide spectrum of pump standards, materials and applications that fulfill the requirement various sectors of industry like marine, power production, oil and gas, chemicals, petrochemicals, marine, naval, fish farming…..etc.`,
        },
        {
          title: "Pump",
          src_file:
            "https://firebasestorage.googleapis.com/v0/b/mining-israa-group.appspot.com/o/website%2Fpumps%2FpumpsCarousel2.webp?alt=media&token=0ef7bd1f-e8f1-4a2e-8bd4-0c3c75560e0d",
          description: `Our expertise extents their services to our valuable clients supporting them sine the selection of the proper pump that serve their purpose going through the installation, commissioning, testing ending with putting the supplied pumps into service.`,
        },
        // {
        //     title: "Pump",
        //     src_file : require("../assets/img/features/aeroland-branding-image-12.png"),
        //     description : "Putting together all of your business's data, rearrange and present in an appealing way to highlight your core values, services, and visions in the local area. Your online website would be a stepping stone for expanding company's visibility."
        // },
      ],
      swiperOption: {
        speed: 600,
        loop: true,
        slidesPerView: 1,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          768: {
            clickable: false,
          },
        },
      },
    };
  },
  computed: {
    //get current carousel items for the current page
    pageItems() {
      if (this.$route.name.includes("Industrial"))
        return this.items.filter((item) => item.title === "Industrial");
      if (this.$route.name.includes("Fish"))
        return this.items.filter((item) => item.title === "Fish");
      if (this.$route.name.includes("Marine"))
        return this.items.filter((item) => item.title === "Marine");
      if (this.$route.name.includes("Oil"))
        return this.items.filter((item) => item.title === "Oil");
      if (this.$route.name.includes("Pumps"))
        return this.items.filter((item) => item.title === "Pump");
    },
  },
  methods: {
    i18n(key, args) {
      return this.$t(key, args);
    },
    handleTitleTranslation(title) {
      if (title === "Industrial") return this.i18n("industrial.title");
      if (title === "Fish") return this.i18n("fish.title");
      if (title === "Marine") return this.i18n("marine.title");
      if (title === "Oil") return this.i18n("oil.title");
      if (title === "Pump") return this.i18n("pump.title");
    },
    handleDescriptionTranslation(title, index) {
      if (title === "Industrial")
        return this.i18n("industrial.desc." + index.toString());
      if (title === "Fish") return this.i18n("fish.desc." + index.toString());
      if (title === "Marine")
        return this.i18n("marine.desc." + index.toString());
      if (title === "Oil") return this.i18n("oil.desc." + index.toString());
      if (title === "Pump") return this.i18n("pump.desc." + index.toString());
    },
  },
};
</script>
<style lang="scss">
.swiper-pagination .swiper-pagination-bullet-active:before {
  background: #122a50 !important;
}

.hideIfLarge {
  @media screen and (min-width: 575px) {
    visibility: hidden;
    opacity: 0;
  }
}
</style>
